import { Check, ShieldCheck } from "lucide-react";
import SectionHeading from "./SectionHeading";
import { Reveal } from "../shared/Reveal";
import { RESULTS } from "../../data/homeContent";

// Results section — no fabricated testimonials or empty "awaiting content" cards.
// A concise trust statement stands in until real, consented content is available.
export default function Results() {
  return (
    <section className="bg-surface py-20 md:py-28 lg:py-36" data-testid="results-section">
      <div className="container-psv grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        <div className="lg:col-span-5">
          <SectionHeading eyebrow={RESULTS.eyebrow} heading={RESULTS.heading} />
        </div>
        <div className="lg:col-span-7">
          <Reveal className="bg-background border-l-2 border-accent rounded-r-lg p-7 md:p-8">
            <div className="flex items-center gap-2 mb-3">
              <ShieldCheck className="w-5 h-5 text-accent" strokeWidth={1.75} />
              <span className="text-xs uppercase tracking-[0.16em] font-semibold text-accent font-sans">Our approach to results</span>
            </div>
            <p className="text-lg text-secondary-foreground font-light leading-relaxed" data-testid="results-statement">
              {RESULTS.statement}
            </p>
          </Reveal>

          <Reveal delay={0.1} className="mt-8">
            <h3 className="font-sans text-sm uppercase tracking-[0.14em] text-muted-foreground mb-4">Our content rules</h3>
            <ul className="space-y-2.5">
              {RESULTS.rules.map((r) => (
                <li key={r} className="flex items-start gap-3 text-[15px] text-secondary-foreground">
                  <Check className="w-5 h-5 text-accent shrink-0 mt-0.5" strokeWidth={1.5} /> {r}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
